<div class="container-fluid otpComponent">
  <div class="row d-flex justify-content-center" id="mainRow">
    <div class="col-lg-7 px-0" id="carouselDiv">
      <div
        id="carouselExampleControls2"
        class="carousel slide"
        data-bs-ride="carousel"
      >
        <div class="carousel-inner">
          <div class="carousel-item active">
            <img
              src="../../../../assets/images/image1_1.png"
              class="d-block w-100"
              alt="..."
            />
          </div>
          <div class="carousel-item">
            <img
              src="../../../../assets/images/image2_1.png"
              class="d-block w-100"
              alt="..."
            />
          </div>
          <div class="carousel-item">
            <img
              src="../../../../assets/images/image3_1.png"
              class="d-block w-100"
              alt="..."
            />
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4 col-lg-5">
      <div class="row">
        <div class="col-12 text-center mb-4-vw" style="margin-top: 10%">
          <!-- <img src="../../../../assets/images/zoei_logo1.png" width="40%" /> -->
          <img
            src="../../../../assets/images/zoei_logo_black.png"
            width="40%"
          />
          <!-- <img
            src="../../../../assets/images/think_gas2.png"
            width="40%"
          /> -->
        </div>
        <!-- <img src="../../../../assets/images/login_logo.png" width="40%" /> -->
        <div class="col-12 d-flex justify-content-center">
          <div
            class="loginFornt"
            style="font-weight: bold; font-size: 1.736vw; padding-top: 5%"
          >
            Enter the 6-digit code
          </div>
        </div>
        <div class="col-2"></div>
        <div class="col-8 mt-5-vw">
          <form autocomplete="off" [formGroup]="OtpForm">
            <label for="" class="loginFornt fs-12-vw"
              >Check <b>{{ this.mailId }}</b> for the<br />
              verification code.
              <a class="Resend" (click)="ChangemailId()"
                ><b>Change</b></a
              ></label
            ><br />
            <input
              type="text"
              id="username"
              name="username"
              class="w-100 form-control shadow-none fs-14-vw"
              formControlName="OTP"
              placeholder="Enter Code"
              maxlength="6"
              appNumber
              (input)="fieldTouched = true"
            />
            <label class="fs-14-vw" style="float: left; margin-top: 1%"
              ><a class="Resend" (click)="ResendOTP()"
                ><b class="fs-14-vw">Resend Code</b></a
              ></label
            >
            <br />
            <br />
            <br />
            <button
              class="btn w-100 mt-3-vw submitButton shadow-none fs-16-vw"
              type="submit"
              [ngClass]="fieldTouched ? 'cursor' : 'cursorDisabled'"
              (click)="fieldTouched ? OTPSend() : ''"
            >
              Submit
            </button>
            <br />
            <br />
            <span class="loginFornt fs-12-vw"
              >If you don't see the code in your inbox, check your spam folder.
              If it's not there, the email address may not be confirmed or it
              may not match an existing account</span
            >
            <br />
            <br />
            <label
              class="loginFornt fs-14-vw"
              style="float: left; margin-top: 1%"
              ><b><u>Can't access this email?</u></b></label
            >
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
